export default __webpack_public_path__ + "static/rusty-c8c3b7f46c020a16c1a99b902c660af8.jpg";